import { useRef } from "react"
import { Subject } from "rxjs"

export const useSubject = () => {
  const ref = useRef(new Subject())
  return ref.current
}